import { invokePortalLambda } from './portalLambda';

/**
 * Runs one named write on the portal's own records through the portal-admin
 * Lambda (TASK-630): client configs, deploy starts, the agent library, the
 * support docs, the portal's users and the activity log. The browser's role
 * only reads these. The Lambda checks the person's sign-in and staff group,
 * and records the person from the sign-in, never from the request.
 */
export function portalAdmin<T>(action: string, payload: Record<string, unknown> = {}): Promise<T> {
  // The operation name goes last, so a payload field called `action` can never replace it.
  return invokePortalLambda<T>('PORTAL_ADMIN_LAMBDA', { ...payload, action });
}
